<template>
  <a-spin :spinning="loading">
    <div class="perFormIndexContent">
      <div class="indexTitle">成功服务人数</div>
      <div class="topTables">
        <a-table
          :row-key="(_, index) => index"
          style="width: 48%"
          :dataSource="caseDetailInfo?.servicePatientResps || []"
          :columns="servicePatient"
          :pagination="false"
        />
        <a-table
          :row-key="(_, index) => index"
          style="width: 48%"
          :dataSource="caseDetailInfo?.serviceDoctorResps || []"
          :columns="serviceDoctor"
          :pagination="false"
        />
      </div>
      <div class="indexTitle">满意度评价{{ props.adSubTaskRecordId }}</div>
      <div class="formDetail">
        <div v-for="(item, index) in detailConfig" :class="['detailItem', item.class]" :key="index">
          <span class="itemLabel">{{ item.label }}：</span>
          <span class="itemValue" v-if="item.value === 'evaluateLevel'">
            <a-tag v-if="caseDetailInfo[item.value]" color="purple">
              {{ caseDetailInfo[item.value] }}
            </a-tag>
            <span v-else>--</span>
          </span>
          <span v-else class="itemValue">{{ caseDetailInfo[item.value] || '--' }}</span>
        </div>
      </div>
      <a-table
        v-if="caseDetailInfo.evaluateLevel && caseDetailInfo.evaluateLevel !== '一般'"
        :row-key="(_, index) => index"
        :dataSource="caseDetailInfo?.evaluationResps || []"
        :columns="satisfitColumn"
        :pagination="false"
      />
    </div>
  </a-spin>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'
import { apiGetPerformanceIndicators } from '@/api/workPlace/workOrder'

const caseDetailInfo = ref({})
const detailConfig = [
  { label: '评价等级', value: 'evaluateLevel', class: ['sLabel'] },
  { label: '评价人', value: 'userName', class: ['sLabel'] },
  { label: '评价时间', value: 'evaluateTime', class: ['sLabel', 'noBorder'] }
]
const props = defineProps({
  workOrderId: {
    type: String,
    default: '',
    required: true
  },
  adSubTaskRecordId: {
    type: String,
    default: ''
  }
})

const loading = ref(false)
onMounted(() => {
  loading.value = true
  apiGetPerformanceIndicators({
    workOrderId: props.workOrderId,
    adSubTaskRecordId: props.adSubTaskRecordId.split('-')[1]
  })
    .then(res => {
      caseDetailInfo.value = res || {}
      satisfitColumn.value[1].title =
        caseDetailInfo.value.evaluateLevelSign === 1 ? '满意数' : '不满意数'
    })
    .finally(() => {
      loading.value = false
    })
})

const servicePatient = [
  {
    title: '健管',
    dataIndex: 'bd',
    key: 'bd'
  },
  {
    title: '服务患者数',
    dataIndex: 'patient_service_cnt',
    key: 'patient_service_cnt'
  }
]

const serviceDoctor = [
  {
    title: '健管',
    dataIndex: 'bd',
    key: 'bd'
  },
  {
    title: '服务医生数',
    dataIndex: 'doctor_service_cnt',
    key: 'doctor_service_cnt'
  }
]

const satisfitColumn = ref([
  {
    title: '健管',
    dataIndex: 'bd',
    key: 'bd'
  },
  {
    title: '健管数',
    dataIndex: 'satisfaction_cnt',
    key: 'satisfaction_cnt'
  }
])
</script>
<style lang="scss" scoped>
.perFormIndexContent {
  .indexTitle {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-bottom: 12px;
  }
  .topTables {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
  }

  .formDetail {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;

    .detailItem {
      border-bottom: 1px solid #e8e8e8;
      line-height: 44px;
      font-size: 14px;
      position: relative;
      padding: 7.5px 0;
      .itemLabel {
        color: #999999;
      }
      .itemValue {
        color: #333333;
        font-weight: 500;
      }
    }

    .detailItem::after {
      content: '';
      width: 1px;
      border-right: 1px solid #e8e8e8;
      height: 30px;
      background: red;
      position: absolute;
      right: 12px;
      top: 14.5px;
    }

    .noBorder::after {
      display: none;
    }

    .sLabel {
      width: 33.3%;
    }
    .mLabel {
      width: 66.6%;
    }
    .lLabel {
      width: 100%;
      background: #fafafa;
    }
  }
}
</style>
